class C4Radar {
  constructor(axes_selector='') {
    // console.log(Date.now() + " C4Radar constructor")
    this.data = {};
    this.dom_ready = false;
    this.WINDOW_INNER_WIDTH = window.innerWidth;
    this.WINDOW_INNER_HEIGHT = window.innerHeight;
    this.PLATFORM = null;

    this.SYMPTOM_SCORE_MAX = 162;
    this.GSC_MAX = 162;
    this.BESS_ERRORS_MAX = 60;
    this.VOR_MAX = 16;

    this.AXES_LABELS_ALL = ['Symptom Severity', 'Balance', 'Simple RT', 'Choice RT', 'Trails B-A', 'Processing Speed']; //these lines are in the c3radar-axers.js file
    this.AXES_DATA_NAMES_ALL = ['gsc', 'bess_evaluation_errors', 'srt', 'crt', 'trails_diff', 'maps'];

    if (axes_selector === 'c3') {
      this.AXES_LABELS_ALL = ['Symptom Severity', 'Balance', 'Simple RT', 'Choice RT', 'Trails B-A', 'Processing Speed']; //these lines are in the c3radar-axers.js file
      this.AXES_DATA_NAMES_ALL = ['gsc', 'bess_evaluation_errors', 'srt', 'crt', 'trails_diff', 'maps'];
    } else if (axes_selector === 'mental_health') {
      this.AXES_LABELS_ALL = ['Eating Disorder', 'APSQ', 'Anxiety', 'Depression', 'Sleep', 'Alcohol'];
      this.AXES_DATA_NAMES_ALL = ['eating_disorder', 'apsq', 'anxiety', 'depression', 'sleep', 'alcohol'];
    } else if (axes_selector === '') {
      this.AXES_LABELS_ALL = ['Symptom Severity', 'Balance', 'Simple RT', 'Choice RT', 'Trails B-A', 'Processing Speed']; //these lines are in the c3radar-axers.js file
      this.AXES_DATA_NAMES_ALL = ['gsc', 'bess_evaluation_errors', 'srt', 'crt', 'trails_diff', 'maps'];
    } else {
      this.AXES_LABELS_ALL = []
      this.AXES_DATA_NAMES_ALL = [];
    }

    this.axes_labels = this.AXES_LABELS_ALL;
    this.axes_data_names = this.AXES_DATA_NAMES_ALL;
    this.month_names = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    this.chart_colors = ['0,0,0,','255,0,0,','255,153,0,','0,204,255,','0,0,255,','102,0,102,'];
    // this.chart_colors = ['0,0,0,','255,0,0,','255,153,0,','0,204,255,','0,0,255,','102,0,102,','0,0,0,','255,0,0,','255,153,0,','0,204,255,','0,0,255,','102,0,102,'];
    this.display_assessments = [];
    this.compare_index = 1;
    this.hot_spots = [];
    this.axes_radius = 0;
    this.data_radius = 0;
    this.CHART_OFFSET_L = 65;
    this.CHART_OFFSET_R = 60;
    this.LEGEND_OFFSET = 180;
    this.over_link = -1;
    this.is_initialized = false;
    this.has_baseline = false;
    this.NORM_DATA = {"gsc":4.7,"bess_evaluation_errors":12.5,"srt":279,"crt":395,"trails_diff":20.7,"maps":65,"description":"Normative Data","baseline":false,
        "apsq": 17, "anxiety": 10, "depression": 10, "sleep": 8, "alcohol": 3, "drugs": 2, "eating_disorder": 2, "suicide": 1,
        "nutrition": 12.6, "strength": 13.6, "stress": 12.8, "stability": 12.5, "family": 17, "effectiveness": 20.4, "mindfulness": 27.2,
        "tpiq_total": 89.9, "tpiq_pain": 9.5, "tpiq_sleep": 7.8, "coi_nutrition": 77, "coi_strength": 77, "coi_stress": 77, "coi_stability": 77,
        "coi_family": 77, "coi_effectiveness": 77, "coi_mindfulness": 77, "coi_total": 77
    };
    this.show90th = false;
    this.show90Decription = "90% Baseline";

    window.addEventListener('turbo:load', () => {
      this.dom_ready = true;
    });
  }

  sayHiMom(){
    console.log(Date.now() + " Hi mom from sayHiMom")
  }

  updateChart(json_data, chart_width, chart_height) {

    //if (this.dom_ready)
      chart_width = typeof chart_width !== 'undefined' ? chart_width : null;
      chart_height = typeof chart_height !== 'undefined' ? chart_height : null;
      this.loadData(json_data, chart_width, chart_height);
    // } else {
    //   console.log(Date.now() + " C4Radar returning false")
    //   return false;
    // }
  }

  loadData(json_data, chart_width, chart_height) {

    this.data = json_data;
    const IPAD_W = 460;
    const IPAD_H = 460;
    this.hot_spots = [];
    this.display_assessments = [];

    if (chart_width == null || chart_height == null) {
      if (this.data.chart_width == null || this.data.chart_height == null) {
        this.data.chart_width = IPAD_W;
        this.data.chart_height = IPAD_H;
      }
    } else {
      this.data.chart_width = chart_width;
      this.data.chart_height = chart_height;
    }
    // console.log("loadData data.assessments: " + this.data.assessments);

    if (this.data.assessments) {
      if (this.data.assessments.length > 0) {
        if (this.data.assessments[0].description.toLowerCase().indexOf("normative") < 0) {
          this.data.assessments.unshift(this.NORM_DATA);
        }
        if (!!this.data.assessments[1] && this.data.assessments[1].baseline === true) {
          this.has_baseline = true;
          this.show90th = true;
        } else {
          this.has_baseline = false;
          this.compare_index = 0;
        }
      } else {
        this.has_baseline = false;
        this.compare_index = 0;
        this.data.assessments = [this.NORM_DATA];
      }
    } else {
      this.has_baseline = false;
      this.compare_index = 0;
      this.data.assessments = [this.NORM_DATA];
    }
    this.init();
  }

  detectUserAgent() {
    if (navigator.userAgent.match(/iPad/i)) {
      this.PLATFORM = "iPad";
    } else if (navigator.userAgent.match(/iPod/i)) {
      this.PLATFORM = "iPod";
    } else if (navigator.userAgent.match(/iPhone/i)) {
      this.PLATFORM = "iPhone";
    } else if (navigator.userAgent.match(/Android/i)) {
      this.PLATFORM = "Android";
    } else if (navigator.userAgent.match(/Win/i)) {
      this.PLATFORM = "Win";
    } else if (navigator.userAgent.match(/Mac/i)) {
      this.PLATFORM = "Mac";
    } else {
      this.PLATFORM = "UNKNOWN";
    }
  }

  init() {
    // console.log(Date.now() + " C4Radar init")
    this.detectUserAgent();
    let i = 0;
    let k = 0;
    let legend_h;

    for (i = 0; i < this.data.assessments.length; i++) {
      this.display_assessments.push(1);
    }
    if (this.has_baseline === true) {
      if (this.compare_index === 1) {
        this.display_assessments[0] = 0;
      } else {
        this.display_assessments[1] = 0;
      }
    }

    this.countAxes();

    if (this.PLATFORM === "iPad" || this.PLATFORM === "iPhone" || this.PLATFORM === "Android") {
      legend_h = this.data.assessments.length * 45;
    } else {
      legend_h = this.data.assessments.length * 20;
    }
    const max_diameter = Math.round(this.data.chart_width - this.CHART_OFFSET_L - this.CHART_OFFSET_R);
    const differential = max_diameter - (this.data.chart_height - legend_h);
    if (differential > legend_h * 0.8) {
      if (((this.data.chart_width - this.LEGEND_OFFSET - this.CHART_OFFSET_L - this.CHART_OFFSET_R - 30) / this.data.chart_height) > 1) {
        this.axes_radius = Math.round((this.data.chart_height - 30) * 0.5);
      } else {
        this.axes_radius = Math.round((this.data.chart_width - this.LEGEND_OFFSET - this.CHART_OFFSET_L - this.CHART_OFFSET_R - 60) * 0.5);
      }
    } else if (differential > 0) {
      this.axes_radius = Math.round((this.data.chart_width - this.CHART_OFFSET_L - this.CHART_OFFSET_R - differential) * 0.5);
    } else {
      this.axes_radius = Math.round((this.data.chart_width - this.CHART_OFFSET_L - this.CHART_OFFSET_R) * 0.5);
    }
    this.data_radius = Math.round(this.axes_radius * 0.9);

    this.formatRadii();

    this.drawChart(this.axes_labels.length, this.data.chart_width, this.data.chart_height, this.axes_radius, this.data_radius);

    if (this.is_initialized === false) {
      this.setupEventListeners();
    }

    this.is_initialized = true;
  }

  countAxes() {
    let j = 0;
    const temp_array_1 = [];
    const temp_array_2 = [];

    for (let i = 0; i < this.axes_data_names.length; i++) {
      // if (this.data.assessments[this.compare_index][this.AXES_DATA_NAMES_ALL[i]] != null && this.data.assessments[this.compare_index][this.AXES_DATA_NAMES_ALL[i]] !== 'no data') {
      if (this.data.assessments[this.compare_index][this.axes_data_names[i]] != null && this.data.assessments[this.compare_index][this.axes_data_names[i]] !== 'no data') {
        // temp_array_1[j] = this.AXES_LABELS_ALL[i];
        temp_array_1[j] = this.axes_labels[i];
        // temp_array_2[j] = this.AXES_DATA_NAMES_ALL[i];
        temp_array_2[j] = this.axes_data_names[i];
        j++;
      }
    }
    this.axes_labels = temp_array_1;
    this.axes_data_names = temp_array_2;
  }

  formatRadii() {
    for (let i = 1 + Number(this.has_baseline); i < this.data.assessments.length; i++) {
      for (let k = 0; k < this.axes_labels.length; k++) {
        const name = this.axes_data_names[k];
        const assessment = this.data.assessments[i][name];
        const baseline = this.data.assessments[0 + this.compare_index][name];

        if (name === "c3_sss") {
          if (assessment == null || assessment === 'no data') {
            this.data.assessments[i][`${name}_radius`] = 0;
          } else if (this.SYMPTOM_SCORE_MAX - baseline > (this.SYMPTOM_SCORE_MAX - assessment) * 2) {
            this.data.assessments[i][`${name}_radius`] = 0;
          } else {
            this.data.assessments[i][`${name}_radius`] = Math.round((2 - ((this.SYMPTOM_SCORE_MAX - baseline) / (this.SYMPTOM_SCORE_MAX - assessment))) * this.data_radius);
          }
        } else if (name === "gsc") {
          if (assessment == null || assessment === 'no data') {
            this.data.assessments[i][`${name}_radius`] = 0;
          } else if (this.GSC_MAX - baseline > (this.GSC_MAX - assessment) * 2) {
            this.data.assessments[i][`${name}_radius`] = 0;
          } else {
            this.data.assessments[i][`${name}_radius`] = Math.round((2 - ((this.GSC_MAX - baseline) / (this.GSC_MAX - assessment))) * this.data_radius);
          }
        } else if (name === "bess_evaluation_errors") {
          if (assessment == null || assessment === 'no data') {
            this.data.assessments[i][`${name}_radius`] = 0;
          } else if (this.BESS_ERRORS_MAX - baseline > (this.BESS_ERRORS_MAX - assessment) * 2) {
            this.data.assessments[i][`${name}_radius`] = 0;
          } else {
            this.data.assessments[i][`${name}_radius`] = Math.round((2 - ((this.BESS_ERRORS_MAX - baseline) / (this.BESS_ERRORS_MAX - assessment))) * this.data_radius);
          }
        } else if (name === "cap" || name === "maps" || name === "vor_dva") {
          if (assessment == null || assessment === 'no data') {
            this.data.assessments[i][`${name}_radius`] = 0;
          } else if (baseline > assessment * 2) {
            this.data.assessments[i][`${name}_radius`] = 0;
          } else {
            this.data.assessments[i][`${name}_radius`] = Math.round((2 - (baseline / assessment)) * this.data_radius);
          }
        } else if (name === "trails_diff") {
          if (assessment == null || assessment === 'no data') {
            this.data.assessments[i][`${name}_radius`] = 0;
          } else if (baseline < 0) {
            if (assessment < 0) {
              this.data.assessments[i][`${name}_radius`] = Math.round((baseline / assessment) * this.data_radius);
            } else if (assessment > 0) {
              this.data.assessments[i][`${name}_radius`] = 0;
            } else {
              this.data.assessments[i][`${name}_radius`] = 0;
            }
          } else if (baseline > 0) {
            if (assessment < 0) {
              this.data.assessments[i][`${name}_radius`] = Math.round((2) * this.data_radius);
            } else if (assessment > 0) {
              this.data.assessments[i][`${name}_radius`] = Math.round((baseline / assessment) * this.data_radius);
            } else {
              this.data.assessments[i][`${name}_radius`] = Math.round((2) * this.data_radius);
            }
          } else {
            if (assessment < 0) {
              this.data.assessments[i][`${name}_radius`] = Math.round((2) * this.data_radius);
            } else if (assessment > 0) {
              this.data.assessments[i][`${name}_radius`] = 0;
            } else {
              this.data.assessments[i][`${name}_radius`] = Math.round((1) * this.data_radius);
            }
          }
        } else if (name.indexOf('coi') >= 0) {
          if (assessment == null || assessment === 'no data') {
            this.data.assessments[i][`${name}_radius`] = 0;
          } else if (assessment > baseline) {
            this.data.assessments[i][`${name}_radius`] = 0;
          } else {
            this.data.assessments[i][`${name}_radius`] = Math.round((2 - (assessment / baseline)) * this.data_radius);
          }
        } else {
          if (assessment == null || assessment === 'no data') {
            this.data.assessments[i][`${name}_radius`] = 0;
          } else if (assessment > baseline * 2) {
            this.data.assessments[i][`${name}_radius`] = 0;
          } else {
            this.data.assessments[i][`${name}_radius`] = Math.round((2 - (assessment / baseline)) * this.data_radius);
          }
        }
      }
    }
  }

  drawChart(n, w, h, axes_radius, data_radius) {

    // const canvas = document.getElementById("chart1");
    // const context = canvas.getContext("2d");

    const canvas = document.getElementById("chart1");
    if (!canvas) {
      // canvas no longer on the page (e.g., navigated away); do nothing
      return;
    }

    const context = canvas.getContext("2d");
    let format_assessment_data = [];

    canvas.setAttribute('width', w - 1);
    canvas.setAttribute('height', h - 1);
    context.clearRect(0, 0, w, h);
    canvas.setAttribute('width', w);
    canvas.setAttribute('height', h);

    const chart_padding = parseInt(canvas.style.padding);
    const center_y = Math.round(axes_radius) + chart_padding + 2;
    let center_x;
    let legend_icon_size;
    let legend_icon_spacing;

    if (this.PLATFORM === "iPad" || this.PLATFORM === "iPhone" || this.PLATFORM === "Android") {
      center_x = Math.round(axes_radius + this.CHART_OFFSET_L);
      legend_icon_size = 20;
      legend_icon_spacing = 24;
    } else {
      center_x = Math.round(axes_radius + this.CHART_OFFSET_L);
      legend_icon_size = 10;
      legend_icon_spacing = 10;
    }

    context.fillStyle = "rgba(0,0,0,0.75)";
    context.strokeStyle = "rgba(0,0,0,0.5)";
    context.lineWidth = 1;
    context.lineCap = "butt";
    context.textBaseline = "bottom";
    context.textAlign = "left";
    context.font = "normal 12px sans-serif";

    for (let k = 0; k < n; k++) {
      format_assessment_data[k] = axes_radius;
    }

    this.drawPolygon(context, n, center_x, center_y, format_assessment_data, axes_radius, data_radius, 0, true);

    context.stroke();

    context.fillStyle = `rgba(${this.chart_colors[0]}.5)`;
    context.textBaseline = "top";
    context.textAlign = "right";
    context.font = "normal 12px sans-serif";
    context.strokeStyle = `rgba(${this.chart_colors[0]}.3)`;
    context.lineWidth = 1;
    context.fillText("* Missing data.", w - 5, 4);
    context.fillText("\u2020 Truncated polygon/s.", w - 5, 20);
    context.fillStyle = `rgba(${this.chart_colors[0]}.05)`;
    context.fillRect(w - 134.5, 0.5, 134, 39);
    context.strokeRect(w - 134.5, 0.5, 134, 39);

    for (let j = 0; j < this.data.assessments.length; j++) {
      let i;
      if (j > 0) {
        if (this.has_baseline === true && j === 1) {
          i = j;
        } else {
          i = this.data.assessments.length - j + Number(this.has_baseline);
        }
      } else {
        i = j;
      }

      if (i <= 0 + Number(this.has_baseline)) {
        context.fillStyle = `rgba(${this.chart_colors[0]}0.2)`;
        context.strokeStyle = `rgba(${this.chart_colors[0]}1)`;
      } else {
        context.fillStyle = `rgba(${this.chart_colors[i - Number(this.has_baseline)]}0.4)`;
        context.strokeStyle = `rgba(${this.chart_colors[i - Number(this.has_baseline)]}1)`;
      }

      context.lineWidth = 1;
      context.textBaseline = "bottom";
      context.textAlign = "left";
      context.font = "normal 12px sans-serif";
      context.fillRect(w - this.LEGEND_OFFSET, h - context.lineWidth - legend_icon_size - ((legend_icon_size + legend_icon_spacing) * i), legend_icon_size, legend_icon_size);
      context.strokeRect(w - this.LEGEND_OFFSET, h - context.lineWidth - legend_icon_size - ((legend_icon_size + legend_icon_spacing) * i), legend_icon_size, legend_icon_size);

      if (i <= 0 + Number(this.has_baseline)) {
        context.fillStyle = `rgba(${this.chart_colors[0]}1)`;
      } else {
        context.fillStyle = `rgba(${this.chart_colors[i - Number(this.has_baseline)]}1)`;
      }

      context.fillText(this.data.assessments[i].description, w - this.LEGEND_OFFSET + legend_icon_size + Math.round(chart_padding * 0.5), h - Math.round(legend_icon_size * 0) - ((legend_icon_size + legend_icon_spacing) * i));

      if (this.display_assessments[i] === 1) {
        if (this.PLATFORM === "iPad" || this.PLATFORM === "iPhone" || this.PLATFORM === "Android") {
          context.beginPath();
          context.lineWidth = 3;
          context.lineCap = "round";
          context.strokeStyle = "rgba(0, 0 ,0, 1)";
          context.moveTo(w - this.LEGEND_OFFSET + 2, h - Math.round(legend_icon_size * 0.5) - 1 - ((legend_icon_size + legend_icon_spacing) * i));
          context.lineTo(w - 2 - this.LEGEND_OFFSET + Math.round(legend_icon_size * 0.5), h - 4 - ((legend_icon_size + legend_icon_spacing) * i));
          context.lineTo(w - 2 - this.LEGEND_OFFSET + legend_icon_size, h - 6 - legend_icon_size - ((legend_icon_size + legend_icon_spacing) * i));
          context.stroke();
        } else {
          context.beginPath();
          context.lineWidth = 2;
          context.strokeStyle = "rgba(0, 0 ,0, 1)";
          context.moveTo(w - this.LEGEND_OFFSET + 1, h - Math.round(legend_icon_size * 0.5) - 2 - ((legend_icon_size + legend_icon_spacing) * i));
          context.lineTo(w - 1 - this.LEGEND_OFFSET + Math.round(legend_icon_size * 0.5), h - 3 - ((legend_icon_size + legend_icon_spacing) * i));
          context.lineTo(w - 1 - this.LEGEND_OFFSET + legend_icon_size, h - 5 - legend_icon_size - ((legend_icon_size + legend_icon_spacing) * i));
          context.stroke();
        }
      }

      this.hot_spots.splice(1, 0, {
        id: i,
        description: this.data.assessments[i].description,
        left: w - this.LEGEND_OFFSET + chart_padding,
        top: h - legend_icon_size - (legend_icon_spacing * 0.25) - ((legend_icon_size + legend_icon_spacing) * i) + chart_padding,
        width: this.LEGEND_OFFSET,
        height: legend_icon_size + legend_icon_spacing
      });

      if (i <= 0 + Number(this.has_baseline)) {
        context.fillStyle = `rgba(${this.chart_colors[0]}0.2)`;
        context.strokeStyle = `rgba(${this.chart_colors[0]}1)`;
        for (let k = 0; k < n; k++) {
          format_assessment_data[k] = data_radius;
        }
      } else {
        if (this.show90th && this.data.assessments[i].description === this.show90Decription) {
          context.fillStyle = "transparent";
          context.setLineDash([10, 10]);
        } else {
          context.fillStyle = `rgba(${this.chart_colors[i - Number(this.has_baseline)]}0.4)`;
          context.setLineDash([]);
        }

        context.strokeStyle = `rgba(${this.chart_colors[i - Number(this.has_baseline)]}1)`;
        for (let k = 0; k < n; k++) {
          format_assessment_data[k] = this.data.assessments[i][`${this.axes_data_names[k]}_radius`];
        }
      }

      if (this.display_assessments[i] === 1) {
        context.lineWidth = 2;
        context.lineCap = "butt";
        context.beginPath();
        this.drawPolygon(context, n, center_x, center_y, format_assessment_data, axes_radius, data_radius, 0, false);
        format_assessment_data.length = 0;
        context.fill();
        context.stroke();
      }
    }
  }

  drawPolygon(ctx, n, x, y, r, axes_radius, data_radius, angle, axes, counterclockwise) {
    // console.log(Date.now() + " C4Radar drawPolygon")
    angle = angle || 0;
    axes = axes || false;
    counterclockwise = counterclockwise || false;
    let i = 0;
    let temp_string = this.axes_labels[i];
    if (axes) {
      ctx.moveTo(x, y);
      ctx.lineTo(x + r[i] * Math.sin(angle), y - r[i] * Math.cos(angle));
      ctx.moveTo(x, y);
      for (let j = 1; j < this.data.assessments.length; j++) {
        if ((this.data.assessments[j][this.axes_data_names[i]] == null || this.data.assessments[j][this.axes_data_names[i]] === 'no data') && this.display_assessments[j] === 1) {
          temp_string += " *";
          break;
        }
      }
      for (let j = 1; j < this.data.assessments.length; j++) {
        if (this.data.assessments[j][`${this.axes_data_names[i]}_radius`] > axes_radius && this.display_assessments[j] === 1) {
          temp_string += " \u2020";
          break;
        }
      }
      ctx.fillText(temp_string, x + r[i] * Math.sin(angle) - Math.round(ctx.measureText(temp_string).width * 0.5), y - r[i] * Math.cos(angle));
    } else {
      if (r[i] > axes_radius) {
        r[i] = axes_radius;
      }
      ctx.moveTo(x + r[i] * Math.sin(angle), y - r[i] * Math.cos(angle));
    }
    const delta = 2 * Math.PI / n;
    for (i = 1; i < n; i++) {
      angle += counterclockwise ? -delta : delta;
      temp_string = this.axes_labels[i];
      if (axes) {
        ctx.moveTo(x, y);
        ctx.lineTo(x + r[i] * Math.sin(angle), y - r[i] * Math.cos(angle));
        ctx.moveTo(x, y);
        ctx.textAlign = (angle >= Math.PI) ? "right" : "left";
        ctx.textBaseline = (angle > (Math.PI) * 0.5 && angle < (Math.PI) * 1.5) ? "top" : "bottom";
        for (let j = 1; j < this.data.assessments.length; j++) {
          if ((this.data.assessments[j][this.axes_data_names[i]] == null || this.data.assessments[j][this.axes_data_names[i]] === 'no data') && this.display_assessments[j] === 1) {
            temp_string += " *";
            break;
          }
        }
        for (let j = 1; j < this.data.assessments.length; j++) {
          if (this.data.assessments[j][`${this.axes_data_names[i]}_radius`] > axes_radius && this.display_assessments[j] === 1) {
            temp_string += " \u2020";
            break;
          }
        }
        if (this.axes_labels[i] === "Processing Speed") {
          ctx.fillText("Processing", x + r[i] * Math.sin(angle) - 4, y - r[i] * Math.cos(angle));
          ctx.fillText(temp_string.replace("Processing ", ""), x + r[i] * Math.sin(angle) - 4, y - r[i] * Math.cos(angle) + 14);
        } else {
          ctx.fillText(temp_string, x + r[i] * Math.sin(angle), y - r[i] * Math.cos(angle));
        }
      } else {
        if (r[i] > axes_radius) {
          r[i] = axes_radius;
        }
        ctx.lineTo(x + r[i] * Math.sin(angle), y - r[i] * Math.cos(angle));
      }
    }
    if (!axes) {
      ctx.closePath();
    }
  }

  setupEventListeners() {
    const canvas = document.getElementById("chart1");
    if (!canvas) return; // nothing to bind to (e.g., after navigation)
    const canvasLeft = canvas.offsetLeft;
    const canvasTop = canvas.offsetTop;
    let x;
    let y;

    if (canvas.addEventListener) {
      canvas.addEventListener("mousemove", (event) => {
        const targ = event.target || event.srcElement;
        // if (targ.nodeType === 3) {
        //   targ = targ.parentNode;
        // }
        this.over_link = -1;

        if (typeof jQuery !== 'undefined') {
          x = event.pageX - $(targ).offset().left;
          y = event.pageY - $(targ).offset().top;
        } else {
          x = event.pageX - canvasLeft;
          y = event.pageY - canvasTop;
        }

        this.hot_spots.forEach((element) => {
          if (y > element.top && y < element.top + element.height && x > element.left && x < element.left + element.width) {
            this.over_link = element.id;
            if (this.over_link >= 0) {
              document.body.style.cursor = "pointer";
            }
          } else {
            if (this.over_link === -1) {
              document.body.style.cursor = "";
            }
          }
        });
      }, false);

      canvas.addEventListener("click", (event) => {
        if (this.over_link >= 0) {
          event.preventDefault();
          if (this.over_link <= 0 + Number(this.has_baseline)) {
            if (this.has_baseline === true) {
              this.display_assessments[this.over_link] = (this.display_assessments[this.over_link] === 1) ? 0 : 1;
              this.display_assessments[Math.abs(this.over_link - 1)] = (this.display_assessments[Math.abs(this.over_link - 1)] === 1) ? 0 : 1;
              this.compare_index = this.compare_index === 1 ? 0 : 1;
              this.countAxes();
              this.formatRadii();
              this.drawChart(this.axes_labels.length, this.data.chart_width, this.data.chart_height, this.axes_radius, this.data_radius);
            }
          } else {
            this.display_assessments[this.over_link] = (this.display_assessments[this.over_link] === 1) ? 0 : 1;
            this.drawChart(this.axes_labels.length, this.data.chart_width, this.data.chart_height, this.axes_radius, this.data_radius);
          }
        }
      }, false);
    } else if (canvas.attachEvent) {
      canvas.attachEvent("onmousemove", (event) => {
        this.over_link = -1;

        if (typeof jQuery !== 'undefined') {
          x = event.pageX - $(targ).offset().left;
          y = event.pageY - $(targ).offset().top;
        } else {
          x = event.pageX - canvasLeft;
          y = event.pageY - canvasTop;
        }

        for (let i = 0; i < this.hot_spots.length; i++) {
          if (y > this.hot_spots[i].top && y < this.hot_spots[i].top + this.hot_spots[i].height && x > this.hot_spots[i].left && x < this.hot_spots[i].left + this.hot_spots[i].width) {
            this.over_link = this.hot_spots[i].id;
            if (this.over_link >= 0) {
              document.body.style.cursor = "pointer";
            }
          } else {
            if (this.over_link === -1) {
              document.body.style.cursor = "";
            }
          }
        }
      });

      canvas.attachEvent("onclick", (event) => {
        if (this.over_link >= 0) {
          event.preventDefault();
          if (this.over_link <= 0 + Number(this.has_baseline)) {
            if (this.has_baseline === true) {
              this.display_assessments[this.over_link] = (this.display_assessments[this.over_link] === 1) ? 0 : 1;
              this.display_assessments[Math.abs(this.over_link - 1)] = (this.display_assessments[Math.abs(this.over_link - 1)] === 1) ? 0 : 1;
              this.compare_index = this.compare_index === 1 ? 0 : 1;
              this.countAxes();
              this.formatRadii();
              this.drawChart(this.axes_labels.length, this.data.chart_width, this.data.chart_height, this.axes_radius, this.data_radius);
            }
          } else {
            this.display_assessments[this.over_link] = (this.display_assessments[this.over_link] === 1) ? 0 : 1;
            this.drawChart(this.axes_labels.length, this.data.chart_width, this.data.chart_height, this.axes_radius, this.data_radius);
          }
        }
      });
    }
  }
}

export default C4Radar;
